<template>
  <div>
    <Row :gutter="8" class="m-b-5">
      <i-col :xs="24" :sm="6" :md="3" :lg="6" class="m-b-5">
        <i-input
          size="small"
          v-model="query.queryString"
          clearable
          placeholder="关键字：支持合同名称、客户名称、合同编号查询"
        ></i-input>
      </i-col>
      <i-col :xs="24" :sm="6" :md="12" :lg="12" class="m-b-5">
        <Button
          size="small"
          type="primary"
          icon="ios-search"
          @click="SearchData"
          >搜索</Button
        >
      </i-col>
    </Row>
    <Table
      size="small"
      :columns="columnManagedata"
      :data="tableData"
      :loading="tableLoading"
      stripe
    ></Table>
    <div class="paging_style">
      <Page
        size="small"
        :total="total"
        :page-size="query.pageSize"
        show-total
        show-elevator
        :current="query.pageNumber"
        @on-change="changePage"
      ></Page>
    </div>
  </div>
</template>

<script>
import { toMoney } from '@/utils/wnumb_own'

import { countAmountGbContract } from '@/api/invest/debt'

export default {
  data () {
    return {
      total: 0,
      query: {
        pageNumber: 1,
        pageSize: 15,
        queryString: ''
      },
      tableLoading: false,
      tableData: [],
      columnManagedata: [
        { title: '合同编号', key: 'code', width: 120 },
        { title: '合同名称', key: 'name' },
        { title: '客户名称', key: 'advertiserName' },
        { title: '开始日期', key: 'startDate', width: 100 },
        { title: '结束日期', key: 'endDate', width: 100 },
        {
          title: '账单总额',
          key: 'total',
          width: 120,
          render: (h, params) => {
            return h('span', {},
              toMoney(params.row.amount + params.row.settleAmount + params.row.doneAmount))
          }
        },
        {
          title: '待收款',
          key: 'amount',
          width: 120,
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.amount))
          }
        },
        {
          title: '收款中',
          key: 'settleAmount',
          width: 120,
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.settleAmount))
          }
        },
        {
          title: '已收款',
          key: 'doneAmount',
          width: 120,
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.doneAmount))
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          render: (h, params) => {
            const detailButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$store.commit('set_debt_contractId', params.row.contractId)
                    this.$store.commit('set_debt_pageType', 'detail')
                  }
                }
              },
              '详情'
            )

            return h('div', [detailButton])
          }
        }
      ]
    }
  },
  created () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      this.tableLoading = true
      countAmountGbContract(this.query).then((response) => {
        this.total = response.total
        this.tableData = response.records
        this.query.pageNumber = response.current
      }).finally(() => { this.tableLoading = false })
    },
    changePage (currentPage) {
      this.query.pageNumber = currentPage
      this.initPageData()
    },
    SearchData () {
      this.query.pageNumber = 1
      this.initPageData()
    }
  }
}
</script>
